import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

import { BroadcastChannelService } from '@connect-services/client/services/broadcast-channel.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, TranslocoPipe],
    selector: 'app-synoptic-window-button',
    styleUrl: './synoptic-window-button.component.scss',
    templateUrl: './synoptic-window-button.component.html',
})
export class SynopticWindowButtonComponent {
    public readonly title: InputSignal<string> = input<string>('newWindow');
    public readonly windowPath: InputSignal<string> = input.required<string>();

    protected readonly broadcastChannelService = inject(BroadcastChannelService);
    protected readonly ButtonType = ButtonType;
    protected readonly document = document;
}
